const DailyData = [
    {
      id: 1,
      day: 'Monday',
      name: "Summer BBQ",
      description: 'BBq chicken breast shredded and rested in tangy bbq sauce, melted smoked gouda and sharp American cheese, elote mayo, crunchy cabbage slaw with fresh herbs, pickle chips, split French roll.',
    },
    {
      id: 2,
      day: 'Tuesday',
      name: "Italian Summer",
      description: "Roast Turkey, prosciutto, fresh mozzarella, artichoke hearts, mayo, homemade basil pesto, pepperoncini, red onion, arugula, balsamic reduction, French roll.",
    },
    {
      id: 3,
      day: 'Wednesday',
      name: "Midnight Toker",
      description: "Roast Beef, baby Swiss, 1000 island, Arugula, red onion, tomato, HS chilis, toasty sliced sourdough.",
    },
    {
      id: 4,
      day: 'Thursday',
      name: "Keep Tahoe blue",
      description: "Smoked turkey, bacon, sharp provolone, avocado, mayo, blueberry compote, red onion, arugula, HS chilis, tajin, Dutch crunch.",    },
    {
        id: 5,
        day: 'Friday',
        name: "Maui Wowii",
        description: "Chicken breast, melted Swiss, bacon, Avocado, Mayo, Japanese BBQ sauce, roasted pineapple chutney, red onion, tomato, Romaine, on Dutch Crunch.",
      },
      {
        id: 6,
        day: 'Saturday',
        name: "Dopa Dopa",
        description: "Smoked Turkey, Bacon, Philadelphia cream cheese, guava jam, arugula, HS chilis, red onion, dijonaise, Dutch Crunch.",
      },
      {
        id: 7,
        day: 'Sunday',
        name: "Hooligan",
        description: "Smoked turkey, Genoa salami, melted jack cheese, pickled jalapeno, avocado, the works, Hooligan sauce, toasted sliced sourdough.",
      }
  ];
  
  export default DailyData;